import { css } from 'styled-components';
import { focusRing } from '@/app/components/search/styles/mixins';

/**
 * The app's standard modal close button — the look BasicModalHeaderV2 gives every Evo
 * modal (room details, search modals): a 40x40 hit area with a rounded hover/pressed
 * background and the shared CloseIcon at 13px.
 *
 * Appearance only: callers keep their own positioning, since some sit in a flex row and
 * others are absolutely placed against a centred title.
 *
 * The `&&&` on the icon rule is deliberate — it outranks OpenXModal's
 * `[class*='DialogHeader__HeaderContainer'] svg` sizing, so a button rendered inside a
 * dialog header keeps this size instead of inheriting the header's.
 */
export const modalCloseButton = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: unset;
  cursor: pointer;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};

  &:hover {
    background-color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundNeutralHover};
  }

  &:active {
    background-color: ${({ theme }) => theme.kallisto.color.background.interactive.backgroundNeutralPressed};
  }

  &:focus-visible {
    ${focusRing};
  }

  &&& svg {
    flex-shrink: 0;
    width: 13px;
    height: 13px;
  }
`;
